<template>
    <div class="box">
        <div class="midTitle">
            <localized-text localizedKey="Acquisti cliente" text="Acquisti cliente"></localized-text>
        </div>
        <div class="opTableScroller">
            <table class="opTable table table-striped">
                <thead>
                    <tr>
                        <td><localized-text localizedKey="Data acquisto" text="Data acquisto"></localized-text></td>
                        <td><localized-text localizedKey="Carrello" text="Carrello"></localized-text></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in (purchases as OM.Purchase[])" :key="i">
                        <td>
                            {{$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')}}
                        </td>
                        <td>
                            <u>{{item.purchasedOffers.length}} 
                                <localized-text localizedKey="elementi" text="elementi"></localized-text>
                            </u><br/>
                            <div v-for="(offer, i) in item.purchasedOffers" :key="i">
                                <small>- {{offer.name}} </small><b>(x{{offer.quantity}})</b>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { PurchaseClient } from '@/services/Services';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class customerPurchases extends Vue {
 
    @Prop() user: OM.Lead;

    purchases: OM.Purchase[] = [];

    created(){
        this.init();
    }

    init(){
        PurchaseClient.getByCliente(this.user.identifier, true).then(x => this.purchases = x);
    }

}

</script>
